export const ASSETS_DELETED = 'ASSETS_DELETED';
export const ASSETS_REASSIGNED = 'ASSETS_REASSIGNED';
export const ASSET_DUPLICATED = 'ASSET_DUPLICATED';

export const REPORT_DELETED = 'REPORT_DELETED';

export const PROJECT_FEATURED_PHOTO_CHANGED = 'PROJECT_FEATURED_PHOTO_CHANGED';

export const PROJECT_LABEL_CREATED = 'PROJECT_LABEL_CREATED';
export const PROJECT_LABEL_DELETED = 'PROJECT_LABEL_DELETED';
